(function () {
    'use strict';

    angular
        .module('app')
        .controller('FieldSelectorDialog', FieldSelectorDialog);

    FieldSelectorDialog.$inject = ['DialogInstance', 'entityTemplate', 'entityTemplates', 'includeOrganisation', 'includeCurrentUser', 'includeDocumentTemplate', 'includeFileDetails',
        'excludeFileDetailsName', 'includeEntitySystem', 'includeEntitySystemForPreview', 'includeEntitySystemForSearch', 'firstLevelFieldsOnly', 'multiSelect',
        'fieldFormatter', 'selectedFields'];

    /**
     * Dialog for displaying a field selector.
     * A field selector allows the user to select fields from an entity template.
     *
     * @param {object} entityTemplate - The entity template to show fields for.
     * @param {array} entityTemplates - Related entity templates, and if 'includeOrganisation' is true, 
     *   the organisation entity template and any of its related entity templates.
     * @param {bool} includeOrganisation - Optional, default is false. True if fields for the 'Organisation'
     *   entity template are to be included.
     * @param {bool} includeCurrentUser - Optional, default is false. True if fields for the current user
     *   are to be included.
     * @param {bool} includeDocumentTemplate - Optional, default is false. True if fields for the 'Document Template'
     *   are to be included in the Insert Field dialog.
     * @param {bool} includeFileDetails - Optional, default is false. True if fields for the 'File'
     *   are to be included in the Insert Field dialog.
     * @param {bool} excludeFileDetailsName - Optional, default is false. True if 'Name' field for the 'File'
     *   is to be excluded in the Insert Field dialog.
     * @param {bool} includeEntitySystem - Optional, default is false. True if system fields for the entity
     *   are to be included in the Insert Field dialog.
     * @param {bool} includeEntitySystemForPreview - Optional, default is false. True if system fields for the entity preview
     *   are to be included in the Insert Field dialog.
     * @param {bool} includeEntitySystemForSearch - Optional, default is false. True if system fields for the entity search
     *   are to be included in the Insert Field dialog.
     * @param {bool} firstLevelFieldsOnly - Optional, default is false. True if only the first-level fields
     *   of the entity template should be shown.
     * @param {bool} multiSelect - Optional, default is false. True if it should be possible for multiple
     *   fields to be selected.
     * @param {object} fieldFormatter - Optional, default is FieldSelectorService.fieldFormatters.simple
     *   One of the field formatters in FieldSelectorService.fieldFormatters
     * @param {array} selectedFields - Optional. Array of {string} for selected fields, in the format of the
     *   provided field formatter, e.g. ['[[ChilliDocs:Cats.Species]]', '[[ChilliDocs:Cats.Name]]']
     *
     * @returns {array} A list of the selected nodes.
     */
    function FieldSelectorDialog(DialogInstance, entityTemplate, entityTemplates, includeOrganisation, includeCurrentUser, includeDocumentTemplate, includeFileDetails, excludeFileDetailsName,
        includeEntitySystem, includeEntitySystemForPreview, includeEntitySystemForSearch, firstLevelFieldsOnly, multiSelect, fieldFormatter, selectedFields) {
        /* jshint validthis:true */
        var vm = this;
        vm.entityTemplate = entityTemplate;
        vm.entityTemplates = entityTemplates;
        vm.includeOrganisation = includeOrganisation;
        vm.includeCurrentUser = includeCurrentUser;
        vm.includeDocumentTemplate = includeDocumentTemplate;
        vm.includeFileDetails = includeFileDetails;
        vm.excludeFileDetailsName = excludeFileDetailsName;
        vm.includeEntitySystem = includeEntitySystem;
        vm.includeEntitySystemForPreview = includeEntitySystemForPreview;
        vm.includeEntitySystemForSearch = includeEntitySystemForSearch;
        vm.firstLevelFieldsOnly = firstLevelFieldsOnly;
        vm.multiSelect = multiSelect;
        vm.fieldFormatter = fieldFormatter;
        vm.selectedFields = selectedFields;
        vm.ok = ok;
        vm.cancel = cancel;
        Object.defineProperty(vm, 'okDisabled', {
            get: function () {
                if (multiSelect) {
                    return false;
                } else {
                    return _.isNil(vm.selectedFields) || vm.selectedFields.length === 0;
                }
            }
        });

        function ok() {
            DialogInstance.ok(vm.selectedFields);
        }

        function cancel() {
            DialogInstance.cancel();
        }
    }
})();